import { Radio, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { ModalEditLoopItem } from './ModalLoopItem';
import { ActionButton } from '../../incidentForm/fields/style';
import { useNotifications } from '../../../hooks/useNotifications';

const RadioComponent = ({ field, value, onChange, renderFormItems, nodeHierarchy = [], disabledField }) => {
  const [radioValue, setRadioValue] = useState(value);
  const [showFormModal, setShowFormModal] = useState(false);
  const { showConfirmNotification } = useNotifications();

  const onSelect = (e) => {
    const newValue = e.target.value;
    if (radioValue?.idInput && radioValue.idInput === newValue) return;
    const setNewSelection = () => {
      const newItem = { idInput: newValue, valueConditional: {} };
      setRadioValue(newItem);
      onChange(newItem);
      const radioItem = field.list.find((radio) => radio.idInput === newValue);
      if (radioItem?.conditional) {
        setShowFormModal(true);
      }
    };
    if (radioValue?.valueConditional != null && Object.keys(radioValue.valueConditional).length) {
      showConfirmNotification({
        title: 'areYouSure',
        content: 'willLoseConditionalValues',
        onOk: setNewSelection,
      });
    } else {
      setNewSelection();
    }
  };

  const handleCloseModal = (result) => {
    if (result?.saveValues) {
      const newValue = {
        ...radioValue,
        valueConditional: result.values,
      };
      setRadioValue(newValue);
      onChange(newValue);
    }
    setShowFormModal(false);
  };

  const openConditionalModal = () => {
    setShowFormModal(true);
  };

  useEffect(() => {
    setRadioValue(value);
  }, [value]);

  return (
    <>
      <Radio.Group value={radioValue?.idInput} onChange={onSelect} style={{ width: '100%' }}>
        {field.list.map((item) => (
          <Row key={item.idInput} justify="space-between" style={{ width: '100%' }}>
            <Radio value={item.idInput} disabled={disabledField}>
              <span>{item.label}</span>
            </Radio>
            {radioValue?.idInput === item.idInput && item.conditional ? (
              <span>
                <ActionButton type="secondary" onClick={openConditionalModal} icon={<EditOutlined />} />
                {showFormModal ? (
                  <ModalEditLoopItem
                    title={`${field.label}: ${item.label}`}
                    fields={item.list}
                    values={radioValue.valueConditional}
                    renderFields={renderFormItems}
                    show={showFormModal}
                    handleClose={handleCloseModal}
                    nodeHierarchy={[...nodeHierarchy, { idInput: field.idInput }, { idInput: item.idInput }]}
                  />
                ) : null}
              </span>
            ) : null}
          </Row>
        ))}
      </Radio.Group>
    </>
  );
};

export default RadioComponent;

RadioComponent.propTypes = {
  field: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func,
  renderFormItems: PropTypes.func,
  nodeHierarchy: PropTypes.array,
  disabledField: PropTypes.bool,
};
